import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import { styles } from "../../../styles";
import { IconClose, IconInfo } from "../../../components/Icons";
import Button from '../../../components/Button';
import { ContainerWasCheckedImage } from "./ContainerWasCheckedImage";


type ContainerCheckedModalContentProps = {
    onClose: () => void;
    onAdd: () => void;
}

const Wrapper = styled.div`
    overflow-y: hidden;
    display: flex;
    flex-direction: column;
    max-height: 80vh;

    @media (max-width: 480px) {
        max-height: 100vh;
        height: 100%;
    }
`;

const ContentWrapper = styled.div`
    overflow-y: auto;
    position: relative;
    max-height: 80vh;
    padding-right: 24px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media (max-width: 480px) {
        max-height: 100vh;
        height: 100%;
    }
`;

const ModalHeading = styled.h2`
    color: ${styles.textColorSecondary700};
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: sticky;
    top: 0;
    z-index: 1;
    background-color: #fff;
    padding-top: 24px;
    padding-bottom: 24px;
    padding-right: 24px;
    border-radius: 8px;
    margin-bottom: 0;

    svg {
        cursor: pointer;
    }
`;

const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 24px;
`;

const ModalContentText = styled.div`
    color: ${styles.textColorSecondary700};
    
    p {
        margin: 9px 0 0px;
        font-family: 'Satoshi Bold';
        text-align: center;
    }

    p:nth-of-type(2) {
        margin: 0 0 8px;
    }
`;

const InfoText = styled.div`
    font-size: 12px;
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-top: 10px;

    svg { 
        width: 24px; 
        height: 24px;
        flex-shrink: 0;
    }
`;

const BottomRow = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 30px;
    margin-top: 48px;

    button {
        width: 156px;
    }

    @media (max-width: 480px) {
        margin-bottom: 0;
        flex-direction: column;
        align-items: flex-end;
        gap: 12px;
        width: 100%;

        button {
            width: 100%;
            margin-bottom: 0;
        }
    }
`;

export const ContainerCheckedModalContent: React.FC<ContainerCheckedModalContentProps> = ({ onClose, onAdd }) => {
    const { t } = useTranslation();

    return (
        <Wrapper>
            <ModalHeading>{t("pages.myContainers.containerCheckedModal.header")} <div onClick={onClose}><IconClose /></div></ModalHeading>
            <ContentWrapper>
            <ModalContent>
                <ContainerWasCheckedImage />
                <ModalContentText>
                    <p>{t('pages.myContainers.containerCheckedModal.weAreAlreadyThere')}</p>
                    <p>{t('pages.myContainers.containerCheckedModal.afterSuccessfulCheckText')}</p>
                </ModalContentText>
                <ModalContentText>
                    <InfoText><IconInfo /> <span>{t('pages.myContainers.containerCheckedModal.infoText1')}</span></InfoText>
                    <InfoText><IconInfo /> <span>{t('pages.myContainers.containerCheckedModal.infoText3')}</span></InfoText>
                    <InfoText><span>{t('pages.myContainers.containerCheckedModal.infoText2')}</span></InfoText>
                </ModalContentText>
            </ModalContent>

            <BottomRow>
                <Button onClick={onAdd} style={{width: '100%'}}>
                    {t("buttons.addAdditionalContainer")}
                </Button>
                <Button onClick={onClose}>
                    {t("buttons.close")}
                </Button>
            </BottomRow>
            </ContentWrapper>
        </Wrapper>
    );
};